module.exports = __webpack_public_path__ + "static/img/image_home_03.0fbec45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_03.png
// module id = i8t8
// module chunks = 10